import React, { useEffect, useState } from "react";
import image1 from "../../../assets/img/gallery/grallery1.jpg";
import image2 from "../../../assets/img/gallery/grallery2.jpg";
import image3 from "../../../assets/img/gallery/gallery3.jpg";
import image4 from "../../../assets/img/gallery/gallery4.jpg";
import image5 from "../../../assets/img/gallery/gallery5.jpg";
import image6 from "../../../assets/img/gallery/gallery6.jpg";
import image7 from "../../../assets/img/gallery/gallery7.jpg";
import UserAPI from "../../../api/services/userapi";
import { baseURL } from "../../../api/api";
import NoDataFound from '../../../assets/img/nodata-found.png';
import { Modal } from "react-bootstrap";
import Loading from "../../common/loading";
import './index.css'

function GalleryInfo() {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [gallery, setgallery] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setcurrentPage] = useState(1);
  const [recordsPerPage, setrecordsPerPage] = useState(1000);
  const [loading, setLoading] = useState(false);

  const galleryAPI = async (page) => {
    setLoading(true);
    try {
      const responseData = await UserAPI.galleryAPIEP({
        pageIndex: page - 1,
        dataLength: recordsPerPage,
      });
      if (responseData.apiStatus.code === "200") {
        setTimeout(() => { setLoading(false) }, 500)
        //  setLoading(false);
        setgallery(responseData.responseData.galleryInfo);
        const totalRecords = responseData.responseData.totalRecordCount;
        setTotalRecords(totalRecords);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    galleryAPI(currentPage);
  }, [currentPage]);

  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const openModal = (project) => {
    setSelectedProject(project); // optional
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const goNext = () => {
    const currentIndex = gallery.findIndex(
      p => p.id === selectedProject.id
    );
    const nextIndex = (currentIndex + 1) % gallery.length;
    setSelectedProject(gallery[nextIndex]);
  };

  const goPrev = () => {
    const currentIndex = gallery.findIndex(
      p => p.id === selectedProject.id
    );
    const prevIndex = (currentIndex - 1 + gallery.length) % gallery.length;
    setSelectedProject(gallery[prevIndex]);
  };

  const truncateText = (html, limit = 100) => {
    if (!html) return "";

    // Remove HTML tags
    const plainText = html.replace(/<[^>]+>/g, "");

    if (plainText.length <= limit) return plainText;

    return plainText.substring(0, limit) + "...";
  };

  return (
    <div className="container">
      <div className="row mb-5 container-fluid">
        <div className="container section-title mt-4">
          <h2>Gallery</h2>
          <p>A collection of our latest and most memorable moments.</p>
        </div>

        {loading ? (
          <Loading />
        ) :
          gallery.length === 0 ? (
            <div className="d-flex justify-content-center">
              <img
                src={NoDataFound}
                alt="No data found"
                style={{ maxWidth: "250px", height: "100%" }}
              />
            </div>
          ) : (gallery.map((item, index) => (
            <div
              key={index}
              className="col-md-3 mt-3 d-flex justify-content-center"
            >
              <div className="card">
                <div className="profile-pic">
                  <img
                    src={baseURL + item.path + item.altered_file_name}
                    alt={item.heading}
                    className="img-fluid"
                    style={{ cursor: "pointer" }}
                    onClick={() => setFullscreenImage(baseURL + item.path + item.altered_file_name)}
                  />
                </div>

                <div className="bottom">
                  <div className="content">
                    <span className="name mt-5 text-start">{item.heading}</span>
                    <span
                      className="about-me text-start "

                    > {truncateText(item.description, 20)}</span>
                    {/* <div className="d-flex justify-content-end mt-2">
                    <button
                      key={item.id}
                      className="gallery-btn"
                      onClick={() => openModal(item)}
                    >
                      View
                    </button>
                  </div> */}

                  </div>

                  <div className="bottom-bottom">
                    <button className="button">{item.heading}</button>
                    <button
                      key={item.id}
                      className="button"
                      onClick={() => openModal(item)}
                    >
                      <i class="fa-solid fa-arrow-right-long"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )))}

        {fullscreenImage && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.9)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setFullscreenImage(null)}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                fontSize: "35px",
                background: "transparent",
                border: "none",
                color: "white",
                cursor: "pointer",
                zIndex: 100000,
              }}
            >
              ✕
            </button>

            {/* Fullscreen Image */}
            <img
              src={fullscreenImage}
              alt="fullscreen"
              style={{
                maxWidth: "95vw",
                maxHeight: "95vh",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            />
          </div>
        )}
      </div>

      {/* modal view img */}
      <Modal
        show={selectedProject ? showModal : false}
        onHide={closeModal}
        centered
        size="xl"
        className="project-large-modal"
      >
        <button
          className="project-custom-modal-close-btn"
          onClick={closeModal}
        >
          &times;
        </button>
        <i
          className="bi bi-chevron-left project-nav-arrow project-prev"
          onClick={goPrev}
        ></i>


        <i
          className="bi bi-chevron-right project-nav-arrow project-next"
          onClick={goNext}
        ></i>
        <Modal.Body className="p-4">
          <div className="row">
            <div className="col-md-8 d-flex align-items-center justify-content-center">
              <img
                src={
                  baseURL +
                  selectedProject?.path +
                  selectedProject?.altered_file_name
                }
                className="img-fluid rounded w-100"
                // style={{ maxHeight: "350px", objectFit: "cover" }}
                alt={selectedProject?.title}
              />
            </div>

            <div className="col-md-4">
              <h4 className="fw-bold mb-3">
                {selectedProject?.heading}
              </h4>

              {/* <p className="text-muted mb-2" style={{ fontSize: "12px" }}>
                {selectedProject?.category?.toUpperCase()}
              </p> */}

              <p
                className="text-secondary mb-0"
                style={{ lineHeight: "1.6", textAlign: "justify" }}
                dangerouslySetInnerHTML={{
                  __html: selectedProject?.description || "",
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </div>



  );
}

export default GalleryInfo;
